if (typeof SliderComponent !== 'undefined' && !customElements.get('thumbnail-slider')) {
  class ThumbnailSlider extends SliderComponent {
    constructor() {
      super();
      if (!this.slider || !this.nextButton) return;
      // PC縦モードでは、サムネ列がメイン画像より高いとレイアウトを押し広げてしまう
      // （gridのstretchで背の高い方が行高を支配する）。メイン画像高に同期して内部スクロールさせる。
      this.mainViewer = this.closest('media-gallery')?.querySelector('slider-component:not(.thumbnail-slider)');
      if (this.mainViewer) {
        // メインビューア本体＋各画像を監視（画像は遅延ロードで高さが後から確定し、
        // コンテナはサムネに引き伸ばされ済みでサイズ変化しないため本体監視だけでは不足）。
        const ro = new ResizeObserver(() => this.syncHeight());
        ro.observe(this.mainViewer);
        this.mainViewer.querySelectorAll('img').forEach((img) => {
          ro.observe(img);
          if (!img.complete) img.addEventListener('load', () => this.syncHeight(), { once: true });
        });
      }
      requestAnimationFrame(() => this.syncHeight());
      window.addEventListener('load', () => this.syncHeight());
    }

    syncHeight() {
      // 表示中(is-active)のメイン画像の実高に合わせる（コンテナはサムネに引き伸ばされ得るので不可）
      const item =
        this.mainViewer &&
        (this.mainViewer.querySelector('.product__media-item.is-active') ||
          this.mainViewer.querySelector('.product__media-item'));
      const target = item && (item.querySelector('img') || item);
      const h = target ? target.getBoundingClientRect().height : 0;
      if (this.vertical && h > 0) {
        this.style.height = h + 'px';
      } else if (!this.vertical) {
        this.style.removeProperty('height');
      }
      this.initPages();
    }

    get vertical() {
      return matchMedia('(min-width: 1025px)').matches;
    }
    get scrollPos() {
      return this.vertical ? this.slider.scrollTop : this.slider.scrollLeft;
    }
    itemStart(el) {
      return this.vertical ? el.offsetTop : el.offsetLeft;
    }
    itemSize(el) {
      return this.vertical ? el.clientHeight : el.clientWidth;
    }
    get viewSize() {
      return this.vertical ? this.slider.clientHeight : this.slider.clientWidth;
    }
    scrollToPos(p) {
      this.slider.scrollTo(this.vertical ? { top: p } : { left: p });
    }

    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((el) => el.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) {
        this.setFade();
        return;
      }
      this.sliderItemOffset = this.itemStart(this.sliderItemsToShow[1]) - this.itemStart(this.sliderItemsToShow[0]);
      if (!this.sliderItemOffset) {
        this.setFade();
        return;
      }
      this.slidesPerPage = Math.floor((this.viewSize - this.itemStart(this.sliderItemsToShow[0])) / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }

    isSlideVisible(el, offset = 0) {
      const last = this.viewSize + this.scrollPos - offset;
      return this.itemStart(el) + this.itemSize(el) <= last && this.itemStart(el) >= this.scrollPos;
    }

    update() {
      if (!this.slider || !this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollPos / this.sliderItemOffset) + 1;

      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          })
        );
      }

      const atStart = this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollPos === 0;
      const atEnd = this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]);

      this.prevButton.toggleAttribute('disabled', atStart);
      this.nextButton.toggleAttribute('disabled', atEnd);
      this.setFade(atStart, atEnd);
    }

    setFade(atStart = true, atEnd = true) {
      let fade = 'none';
      if (this.totalPages > 1) {
        if (atStart && !atEnd) fade = 'end';
        else if (!atStart && atEnd) fade = 'start';
        else if (!atStart && !atEnd) fade = 'both';
      }
      this.dataset.fade = fade;
    }

    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      const pos =
        event.currentTarget.name === 'next'
          ? this.scrollPos + step * this.sliderItemOffset
          : this.scrollPos - step * this.sliderItemOffset;
      this.scrollToPos(pos);
    }

    setSlidePosition(position) {
      this.scrollToPos(position);
    }

    revealItem(el) {
      if (el) this.scrollToPos(this.itemStart(el));
    }
  }

  customElements.define('thumbnail-slider', ThumbnailSlider);

  // 軸切替（回転・リサイズ）時に高さ同期＋再計算
  matchMedia('(min-width: 1025px)').addEventListener('change', () => {
    document.querySelectorAll('thumbnail-slider').forEach((s) => s.syncHeight && s.syncHeight());
  });
}
